import axios from "axios";

// ✅ Attach token to every request
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken");
    // console.log("Axios interceptor config before attaching token:", config);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log("Axios interceptor attached token:", token);
    }

    return config;
});

// ✅ Auto logout when token is expired (401)
axios.interceptors.response.use(
    (response) => {
        console.log("Axios response interceptor received response:", response);
        return response;
    },
    (error) => {
        console.log("Axios response interceptor error:", error);

        if (error.response && error.response.status === 401) {
            console.log("Token expired → Logging out");

            localStorage.removeItem("accessToken");
            localStorage.removeItem("userData");

            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default axios;